  
import React from 'react'


import "react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css"

export default class ActionControls extends React.Component {

    edit(param,value) {
        this.props.onEdit(param,value)
    }

    option(param,value) {
        this.props.onOptionChange(param,value)
    }

    render() {
        console.log('fromlib', this.props.fromLibrary)

        var previewStyle, cropStyle
        var style = {opacity: 0.65, cursor: "not-allowed"}

        if (this.props.previewMode)
            {previewStyle = style}
        else if (this.props.cropMode || this.props.saveMode)
            {cropStyle = style}

        
        let avail_disp = this.props.displays ? this.props.displays.map((item,i) =>             
        
          <button className='btn btn-success' key={i} style={{marginRight:10}} onClick={() => this.props.onDisplayChange(item, i)}>
                             {item.display_id} </button>) : null

        return (
            <div className='controls'>

                      {this.props.displays && this.props.displays.length > 1 && avail_disp}


                      <button style={{'display': this.props.cropMode ? 'inline-block' : 'none'}}  
                              className="btn btn-success btn-controls" 
                              onClick={this.props.getPreview} 
                              title="Generate PicoSign preview."
                      >Preview</button>
                      
                      <button className="btn btn-success" 
                              style={{'display': this.props.saveMode ? 'inline-block' : 'none'}} 
                              onClick={() => this.props.publish(this.props.fromLibrary)}
                              title="Publish image to PicoSign, but don't save it to media library."
                      >Publish</button>
                      
                      <button className="btn btn-success" 
                              style={{'display': this.props.saveMode  ? 'inline-block' : 'none'}} 
                              onClick={this.props.save}
                              title="Save image to media library, don't publish to PicoSign."
                      >Save</button>
                      

                      <button className="btn btn-success" 
                              style={{'display': this.props.saveMode  ? 'inline-block' : 'none'}} 
                              onClick={this.props.savePublish}
                              title="Save image in media library and publish it to PicoSign."
                      >Save & Publish</button>

                      <button style={{'display': this.props.previewMode ? 'inline-block' : 'none'}} 
                              className="btn btn-primary btn-controls" 
                              onClick={this.props.reCrop} 
                              title="Re-crop selected image."
                      >Edit</button>

                      <button className="btn btn-warning btn-controls" 
                              onClick={this.props.loadNew} 
                              title="Exit current selection without saving changes."
                      >Cancel</button>
                      {/* <button className="btn btn-success" onClick={this.props.save}>Publish & Save</button>  */}





            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/components/ActionControls.js